class WaywardVariantIdentifiers extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector("[data-wayward-variants]");
    if (!data) return;

    try {
      this.variants = JSON.parse(data.textContent);
    } catch (error) {
      this.variants = [];
    }

    this.handleVariantChange = this.handleVariantChange.bind(this);
    document.addEventListener("variant:changed", this.handleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.handleVariantChange);
  }

  handleVariantChange(event) {
    const variant = event.detail?.variant || event.detail?.newVariant;
    if (!variant) return;

    const matchingVariant = this.variants.find(
      (item) => String(item.id) === String(variant.id)
    );

    if (matchingVariant) this.render(matchingVariant);
  }

  render(variant) {
    this.updateField("sku", variant.sku);
    this.updateField("barcode", variant.barcode);
  }

  updateField(name, value) {
    const field = this.querySelector(`[data-wayward-${name}]`);
    if (!field) return;

    const row = field.closest(".ww-identifier");
    field.textContent = value || field.dataset.emptyLabel;
    row.hidden = this.dataset.hideEmpty === "true" && !value;
  }
}

if (!customElements.get("wayward-variant-identifiers")) {
  customElements.define("wayward-variant-identifiers", WaywardVariantIdentifiers);
}
